import { createEnv } from "../env/createEnv.js";
import { interact } from "../interact/index.js";
import {} from "../mod/index.js";
import {} from "../net/index.js";
export function runNet(mod, net) {
    const env = createEnv(mod, { net });
    while (net.activeEdges.length > 0) {
        const activeEdge = net.activeEdges.pop();
        if (activeEdge !== undefined) {
            interact(env, activeEdge, {});
        }
    }
}
//# sourceMappingURL=runNet.js.map